module.exports = __webpack_public_path__ + "img/bank-counter-bg-th.9c5fd575.png";